module.exports = __webpack_public_path__ + "static/media/formnoform.7528fe23.gif";